export default "__VITE_ASSET__BPTt13mV__"